import React from 'react'
import DropDownFilterDates from './DropDownFilterDate'

export const CardAnalyticsXl = ({ children, title = "empty", bottomText = "", filter = true, bigHeight = false, callbackDate }) => {
    let classHeight = ''
    if (bigHeight) {
        classHeight = `min-h-[470px] 2xl:min-h-[536px]`
    }
    else {
        classHeight = `min-h-[234px] 2xl:min-h-[300px]`
    }

    return (
        <div className={`w-full  ${classHeight} p-3`}>
            <div className='w-full h-full rounded-2xl bg-white shadow-xl'>
                <div className="flex w-full h-[56px] pt-5 px-4">
                    <div className={filter ? `w-7/12` : `w-11/12`}>
                        <p className="font-normal text-base text-[#686868]">{title}</p>
                    </div>
                    {
                        filter &&
                        <div className="w-5/12 flex justify-end">
                            <div>
                                <DropDownFilterDates callBack={callbackDate}></DropDownFilterDates>
                            </div>
                        </div>
                    }
                </div>
                <div className="w-full h-100-56">
                    {children}
                </div>
                {/* <div className="w-full h-1/6 flex justify-center items-center"> */}
                {/* <p className="font-normal text-md text-[#9A9A9A]">{bottomText}</p> */}
                {/* </div> */}
            </div>
        </div>
    )
}

export default CardAnalyticsXl
